import React from 'react';

import { Link } from 'react-router-dom';

import SelectButton from '../../components/SelectButton';
import NewEventDropZone from '../../components/NewEventDropZone';
import { WizardForm, WizardTab } from '../../components/WizardForm';
import FormDatePicker from '../../components/FormDatePicker';
import ImageDropZone from '../../components/ImageDropZone';

import { KIND_OF_EVENTS, INTERESTS, GMT } from '../../config/list';
import { VIEWER_ZONE_DOMAIN } from '../../config/defaults';

import previewDark from '../../img/previewDark.png';
import previewLight from '../../img/previewLight.png';

import I18n from '../../locales/i18n';

import { TOOLBAR_OPTION } from '../../config/HtmlEditorToolbar';

import DraftEditor from './DraftEditor';

function NewEvent(props) {
	const { assets_progress, docRef = { id: 'NOT_EVENT' } } = props;

	return (
		<div className="az-content az-content-new-event">
			<div className={'az-content-header' + (props.isEditing ? ' hide' : '')}>
				<div className="az-content-header-top">
					<div className="col-md-12">
						<div className="row col-md-12">
							<div className="az-content-breadcrumb">
								<span>
									<Link to="/events">{I18n('EVENTS', 'EVENTS')}</Link>
								</span>
								<span>{I18n('EVENTS', 'NEW_EVENT')}</span>
							</div>
						</div>
						<p className="mg-b-0">{I18n('EVENTS', 'START_INSTRUCTIONS')}</p>
					</div>
				</div>
			</div>
			<div className="az-content-body">
				<WizardForm isEditing={props.isEditing}>
					<WizardTab
						ref={props.formRefs.WT_0}
						isLoading={props.isLoading}
						onSubmit={props.onEventData}
						noSubmit={props.canNotEdit}
						title={I18n('NEW_EVENT', 'EVENT_DATA')}
					>
						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'EVENT_NAME')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<input
									onChange={props.onNameChange}
									value={props.name}
									type="text"
									name="name"
									className="form-control"
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'DATE')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0 two-columns">
								<div>
									<label className="form-label mg-b-0">
										{I18n('NEW_EVENT', 'DATE_FROM')}
									</label>
									<FormDatePicker
										ref={props.formRefs.StartDate}
										name="startDate"
									/>
								</div>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="alert alert-warning" role="alert">
								{I18n('NEW_EVENT', 'REMEMBER_MAX_DURATION')}{' '}
								<strong>{props.maxDuration}</strong>{' '}
								{I18n('NEW_EVENT', 'HOURS_BY_PLAN')}
							</div>
							{/*
                            <div className="col-md-4">
                                <label className="form-label mg-b-0">{I18n("NEW_EVENT", "DURATION")}</label>
                                {(duration > 8) && (
                                )}                                
                            </div>
                            
                            <div className="col-md-8 mg-t-5 mg-md-t-0 two-columns">
                                <div>
                                    <HoursSlider 
                                        min={1}
                                        ref={props.formRefs.Duration}
                                        name="duration"
                                        onChange={(newValue)=>{
                                            setDuration(newValue);
                                        }}
                                        max={props.maxDuration}/>
                                </div>

                            </div>
                            /*/}
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'GMT')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<select
									type="text"
									name="gmt"
									ref={props.gmtSelect}
									className="form-control"
								>
									{GMT.map(function (gmt, index) {
										return (
											<option key={index} value={gmt.value}>
												{gmt.label}
											</option>
										);
									})}
								</select>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'ORGANIZED_BY')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<input
									type="text"
									onChange={props.onOrganizerChange}
									value={props.organizer}
									name="organized"
									className="form-control"
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'YOUR_EVENT_URL')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<h5 className="fake-link">
									{VIEWER_ZONE_DOMAIN}/{props.url}
								</h5>
							</div>
						</div>
					</WizardTab>
					<WizardTab
						ref={props.formRefs.WT_1}
						isLoading={props.isLoading}
						title={I18n('NEW_EVENT', 'EVENT_INFORMATION')}
						onSubmit={props.onEventInformation}
					>
						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'SHORT_DESCRIPTION')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<textarea
									name="short_description"
									className="form-control"
									ref={props.formRefs.short_description}
								></textarea>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'LONG_DESCRIPTION')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<DraftEditor
									toolbar={TOOLBAR_OPTION}
									editorState={props.editorState}
									wrapperClassName="editor-wrapper"
									editorClassName="editor-body"
									localization={{
										locale: props.language,
									}}
									onEditorStateChange={(editorState) =>
										props.onSetState({ editorState })
									}
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'KIND_OF_EVENT')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<select
									type="text"
									name="kind_of_event"
									ref={props.formRefs.kind_of_event}
									className="form-control"
								>
									<option value="">
										{I18n('COMMON', 'PLEASE_SELECT_ONE')}
									</option>
									{KIND_OF_EVENTS.map(function (event, index) {
										return (
											<option key={index} value={event}>
												{I18n('EVENTS', event)}
											</option>
										);
									}, this)}
								</select>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'SHOW_VIEWERS')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<SelectButton
									name="show_viewers"
									options={[
										{ value: true, label: I18n('NEW_EVENT', 'YES_LOG') },
										{
											value: false,
											label: I18n('NEW_EVENT', 'IS_NOT_NECESSARY'),
										},
									]}
									value={props.show_viewers}
									onChange={props.onSelectButtonChange}
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'PRIVACITY')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<SelectButton
									name="privacity"
									options={[
										{ value: 'PUBLIC', label: I18n('NEW_EVENT', 'PUBLIC') },
										{ value: 'PRIVATE', label: I18n('NEW_EVENT', 'PRIVATE') },
									]}
									value={props.privacity}
									onChange={props.onSelectButtonChange}
								/>
								<br />
								<small>{I18n('NEW_EVENT', props.privacity + '_HINT')}</small>
							</div>
						</div>

						{props.privacity === 'PRIVATE' && (
							<React.Fragment>
								<div className="row row-xs align-items-center mg-b-20">
									<div className="col-md-4">
										<label className="form-label mg-b-0">
											{I18n('NEW_EVENT', 'ENABLE_VIEWERS_LOG')}
										</label>
									</div>
									<div className="col-md-8 mg-t-5 mg-md-t-0">
										<SelectButton
											name="record_viewer"
											options={[
												{ value: true, label: I18n('NEW_EVENT', 'YES_LOG') },
												{
													value: false,
													label: I18n('NEW_EVENT', 'IS_NOT_NECESSARY'),
												},
											]}
											value={props.record_viewer}
											onChange={props.onSelectButtonChange}
										/>
									</div>
								</div>
								<div className="row row-xs align-items-center mg-b-20">
									<div className="col-md-4">
										<label className="form-label mg-b-0">
											{I18n('NEW_EVENT', 'LOGIN_METHODS')}
										</label>
									</div>
									<div className="col-md-8 mg-t-5 mg-md-t-0">
										<div className="login-methods">
											<label className="_ckbox">
												<input
													type="checkbox"
													defaultChecked={
														(props.login_methods || { email: true }).email
													}
													name="login_methods_email"
												/>{' '}
												<i className="fas fa-mail-bulk" />{' '}
												<span>{I18n('COMMON', 'EMAIL')}</span>
											</label>

											<label className="_ckbox">
												<input
													type="checkbox"
													defaultChecked={
														(props.login_methods || { code: true }).code
													}
													name="login_methods_code"
												/>{' '}
												<i className="fas fa-cash-register" />{' '}
												<span>{I18n('COMMON', 'CODE')}</span>
											</label>

											<label className="_ckbox">
												<input
													type="checkbox"
													defaultChecked={
														(props.login_methods || { google: true }).google
													}
													name="login_methods_google"
												/>{' '}
												<i className="fab fa-google" /> <span>Google</span>
											</label>

											<label className="_ckbox">
												<input
													type="checkbox"
													defaultChecked={
														(props.login_methods || { facebook: true }).facebook
													}
													name="login_methods_facebook"
												/>{' '}
												<i className="fab fa-facebook-f" /> <span> </span>{' '}
												<span>Facebook</span>
											</label>

											<label className="_ckbox">
												<input
													type="checkbox"
													defaultChecked={
														(props.login_methods || { twitter: true }).twitter
													}
													name="login_methods_twitter"
												/>{' '}
												<i className="fab fa-twitter" /> <span> </span>{' '}
												<span>Twitter</span>
											</label>
										</div>
									</div>
								</div>
								<div className="row row-xs align-items-center mg-b-20">
									<div className="col-md-4">
										<label className="form-label mg-b-0">
											{I18n('NEW_EVENT', 'AUTO_SIGNUP')}
										</label>
									</div>
									<div className="col-md-8 mg-t-5 mg-md-t-0">
										<SelectButton
											name="auto_register"
											options={[
												{ value: true, label: I18n('COMMON', 'ENABLED') },
												{ value: false, label: I18n('COMMON', 'DISABLED') },
											]}
											value={props.auto_register}
											onChange={props.onSelectButtonChange}
										/>
									</div>
								</div>
							</React.Fragment>
						)}

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'CHAT')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<SelectButton
									name="chat"
									options={[
										{ value: true, label: I18n('COMMON', 'ENABLED') },
										{ value: false, label: I18n('COMMON', 'DISABLED') },
									]}
									value={props.chat}
									onChange={props.onSelectButtonChange}
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'QANDA')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<SelectButton
									name="qANDa"
									options={[
										{ value: true, label: I18n('COMMON', 'ENABLED') },
										{ value: false, label: I18n('COMMON', 'DISABLED') },
									]}
									value={props.qANDa}
									onChange={props.onSelectButtonChange}
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'TOPIC')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<select
									type="text"
									name="topic"
									ref={props.formRefs.topic}
									className="form-control"
								>
									<option value="">
										{I18n('COMMON', 'PLEASE_SELECT_ONE')}
									</option>
									{INTERESTS.map(function (event, index) {
										return (
											<option key={index} value={event}>
												{I18n('INTERESTS', event)}
											</option>
										);
									})}
								</select>
							</div>
						</div>
					</WizardTab>
					<WizardTab
						ref={props.formRefs.WT_2}
						isLoading={props.isLoading}
						title={I18n('NEW_EVENT', 'EVENT_ASSETS')}
						onSubmit={props.onEventAssets}
					>
						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'AGENDA')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<NewEventDropZone
									ref={props.formRefs.AssetDropZone_0}
									updateFiles={props.onChangeFiles}
									folder="AGENDA"
									files={props.AGENDA}
									inputProps={{
										accept: 'application/pdf',
										multiple: false,
									}}
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'PANELISTS')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<NewEventDropZone
									ref={props.formRefs.AssetDropZone_1}
									updateFiles={props.onChangeFiles}
									folder="PANELISTS"
									files={props.PANELISTS}
									inputProps={{
										accept: 'application/pdf',
										multiple: false,
									}}
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4">
								<label className="form-label mg-b-0">
									{I18n('NEW_EVENT', 'SUPPORT_MATERIAL')}
								</label>
							</div>
							<div className="col-md-8 mg-t-5 mg-md-t-0">
								<NewEventDropZone
									ref={props.formRefs.AssetDropZone_2}
									updateFiles={props.onChangeFiles}
									folder="SUPPORT_MATERIAL"
									files={props.SUPPORT_MATERIAL}
									inputProps={{
										multiple: true,
									}}
								/>
							</div>
						</div>

						<div
							className={
								'row row-xs align-items-center mg-b-20 ' +
								(assets_progress < 100 ? '' : ' hide')
							}
						>
							<div className="az-traffic-detail-item col-md-12 mg-b-20">
								<div className="progress">
									<div
										className={`progress-bar bg-success`}
										style={{ width: `${assets_progress}%` }}
										role="progressbar"
										aria-valuenow={assets_progress}
										aria-valuemin="0"
										aria-valuemax="100"
									></div>
								</div>
							</div>
						</div>
					</WizardTab>
					<WizardTab
						ref={props.formRefs.WT_3}
						title={I18n('NEW_EVENT', 'EVENT_IMAGE')}
						isLoading={props.isLoading}
					>
						<div className="new-event-images">
							<div className="row row-xs align-items-center mg-b-20 col-md-12">
								<div className="col-md-6">
									<div className="col-md-12 mg-b-20">
										<label className="form-label mg-b-0">
											{I18n('NEW_EVENT', 'FLYER')}
										</label>
										<ImageDropZone
											className="drop event_banner col-md-12"
											type="BANNER"
											eid={docRef.id}
											onChangeImage={props.onChangeImage}
											onDeleteImage={props.onDeleteImage}
											onRequestLoading={props.onRequestLoading}
											photoURL={props.IMAGE_BANNER}
										/>
									</div>

									<div className="col-md-6 col-sm-12 mg-sm-b-20">
										<label className="form-label mg-b-0">
											{I18n('NEW_EVENT', 'SPONSOR_BRAND')}
										</label>

										<ImageDropZone
											className="drop event_avatar col-md-12"
											type="EVENT_AVATAR"
											eid={docRef.id}
											onChangeImage={props.onChangeImage}
											onDeleteImage={props.onDeleteImage}
											onRequestLoading={props.onRequestLoading}
											photoURL={props.IMAGE_EVENT_AVATAR}
										/>
									</div>

									<div className="col-md-6 col-sm-12">
										<label className="form-label mg-b-0">
											{I18n('NEW_EVENT', 'ORGANIZER_BRAND')}
										</label>
										<ImageDropZone
											className="drop organizer_avatar col-md-12"
											type="ORGANIZER_AVATAR"
											eid={docRef.id}
											onChangeImage={props.onChangeImage}
											onDeleteImage={props.onDeleteImage}
											onRequestLoading={props.onRequestLoading}
											photoURL={props.IMAGE_ORGANIZER_AVATAR}
										/>
									</div>
								</div>
								<div className="col-md-6 cnt-event_image_preview">
									<label className="form-label mg-b-0">
										{I18n('NEW_EVENT', 'PAGE_PREVIEW')}
									</label>
									<div className="event_image_preview">
										<div className="event_image_preview-header">
											<i className="fas fa-user-circle"></i>
										</div>
										<div className="event_image_preview-body">
											<div className="event_image_preview-player">
												<i className="fas fa-play-circle"></i>
											</div>
											<div className="event_image_preview-chat">
												<i className="fas fa-receipt"></i>
											</div>
										</div>
										<div className="event_image_preview-title">
											<img
												src={
													props.IMAGE_ORGANIZER_AVATAR +
													`?d=${new Date().getUTCSeconds()}`
												}
												alt="AVATAR"
											/>
										</div>
										<div className="event_image_preview-footer">
											<img
												src={
													props.IMAGE_EVENT_AVATAR +
													`?d=${new Date().getUTCSeconds()}`
												}
												alt="ORGANIZER"
											/>
											<img
												src={
													props.IMAGE_BANNER +
													`?d=${new Date().getUTCSeconds()}`
												}
												alt="INFO"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</WizardTab>
					<WizardTab
						ref={props.formRefs.WT_4}
						isLoading={props.isLoading}
						title={I18n('NEW_EVENT', 'VISUAL_THEME')}
						onSubmit={props.onEventVisualStyle}
					>
						<div className="cntVisualStyle">
							<div
								onClick={(e) => {
									props.onSetState({ player_theme: 'dark' });
								}}
								className={
									'visual-style-option' +
									(props.player_theme === 'dark' ? ' selected' : '')
								}
							>
								<img src={previewDark} alt="theme" />
								<span>{I18n('NEW_EVENT', 'DARK')}</span>
							</div>

							<div
								onClick={(e) => {
									props.onSetState({ player_theme: 'light' });
								}}
								className={
									'visual-style-option' +
									(props.player_theme === 'light' ? ' selected' : '')
								}
							>
								<img src={previewLight} alt="theme" />
								<span>{I18n('NEW_EVENT', 'LIGHT')}</span>
							</div>
						</div>
					</WizardTab>
					<WizardTab
						ref={props.formRefs.WT_5}
						isLoading={props.isLoading}
						title={I18n('NEW_EVENT', 'SOCIAL_NETWORKS')}
						onSubmit={props.onSocialNetworks}
					>
						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4"></div>
							<div className="col-md-8 mg-t-5 mg-md-t-0 social-media-input">
								<i className="fab fa-facebook-f"></i>
								<span>facebook.com/</span>
								<input
									name="facebook"
									ref={props.formRefs.facebook}
									type="text"
									className="form-control"
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4"></div>
							<div className="col-md-8 mg-t-5 mg-md-t-0 social-media-input">
								<i className="fab fa-instagram"></i>
								<span>instagram.com/</span>
								<input
									name="instagram"
									ref={props.formRefs.instagram}
									type="text"
									className="form-control"
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4"></div>
							<div className="col-md-8 mg-t-5 mg-md-t-0 social-media-input">
								<i className="fab fa-twitter"></i>
								<span>twitter.com/</span>
								<input
									name="twitter"
									ref={props.formRefs.twitter}
									type="text"
									className="form-control"
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20">
							<div className="col-md-4"></div>
							<div className="col-md-8 mg-t-5 mg-md-t-0 social-media-input">
								<i className="fab fa-linkedin-in"></i>
								<span>linkedin.com/</span>
								<input
									name="linkedin"
									ref={props.formRefs.linkedin}
									type="text"
									className="form-control"
								/>
							</div>
						</div>

						<div className="row row-xs align-items-center mg-b-20 hide">
							<div className="col-md-4"></div>
							<div className="col-md-8 mg-t-5 mg-md-t-0 social-media-input">
								<i className="fas fa-hashtag"></i>
								<span>Hashtag </span>
								<input
									name="Hashtag"
									ref={props.formRefs.Hashtag}
									type="text"
									className="form-control"
								/>
							</div>
						</div>
					</WizardTab>
				</WizardForm>
			</div>
		</div>
	);
}

export default NewEvent;
